import logger from '../Common/Utils/Logger'
import { msalConfig } from './Config'
import { resetCredentials } from './Redux/Auth'
import { PublicClientApplication } from '@azure/msal-browser'
import { request } from '../Common/Utils/Api'
import api from '../Core/Services/Api'
import history from '../Core/history'
import config from '../Core/Config'

export const msalInstance = new PublicClientApplication(msalConfig)

export const logout = (dispatch, completeInit = () => {}) => {
  msalInstance
    .logoutPopup()
    .then(() => {
      dispatch(resetCredentials())
      history.push(config.urls.login)
      completeInit()
    })
    .catch((err) => {
      logger.warning('Logout flow error:', err)
    })
}

export const fetchUser = async (userName) => {
  try {
    const res = await request(api.users.get, [userName], null, null)

    if (res.response?.statusCode >= 400) {
      history.push(config.urls.forbidden.replace(':error', 'user'))
    } else if (!res.isSuccessful) {
      history.push(config.urls.serverError.replace(':error', 'user'))
    }

    return res.response.data
  } catch (e) {
    logger.error('Fetch current user error: ', e)
    history.push(config.urls.serverError.replace(':error', 'user'))
  }
}
